import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
// import { ApiService } from './api.service';
import { v4 as uuidv4 } from 'uuid';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FcmService {

  subscription = new Subscription;
  currentMessage = new BehaviorSubject(null);
  baseUrl!: String;
  
  constructor(private fireMessage: AngularFireMessaging, 
    private http: HttpClient) { 
      if (environment.appName === "Digikari") {
        this.baseUrl = environment.easyvetUrl;
      } else if (environment.appName === "Partson") {
        this.baseUrl = environment.partsonUrl;
      } else {
        this.baseUrl = environment.bazaarnearUrl;
      }  
  }

  private getUUID(): string {
    let UUID = localStorage.getItem("uuid");
    if (!UUID) {
      UUID = uuidv4();
      console.log(UUID);
      
      localStorage.setItem("uuid", UUID);
    }
    return UUID;
  }

  public initNotification() {
    let user = JSON.parse(localStorage.getItem('admin_Details') ?? "null");
    let isRegisteredForNotification = (localStorage.getItem("isRegisteredForNotification") === "true") ? true : false;
    if (!isRegisteredForNotification && user && environment.production) {
      this.initNotifyRegistration();

    } else if (isRegisteredForNotification && user && environment.production) {
      this.registerServiceWorker();
    }
  }

  // SERVICE WORKER REGISTRATION
  private registerServiceWorker() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('assets/firebase-messaging-sw.js').then((registration) => {
        console.log('Service Worker registered with scope:', registration.scope);
      }).catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
    }
    this.listenForMessages();
  }

  // Display the notification
  private showNotification(title: string, body: string) {
    const options: NotificationOptions = {
      body,
      // icon: icon,
    };
    const notification = new Notification(title, options);
  }

  private requestPermissionFromFirebase(): void {
    this.fireMessage.requestPermission.subscribe((res: any) => {
      console.log(res);
      this.getFCMToken();
    }, (error) => {
      console.error('Unable to get permission to notify.', error);
    });
  }

  private getFCMToken(): void {
    this.fireMessage.getToken.subscribe((token) => {
      console.log('FCM Token:', token);
      this.registerDevice(token);
    }, (error) => {
      console.error('Error getting FCM token:', error);
    });
  }

  private registerDevice(fcmToken: string) {
    let params = {
      deviceId: this.getUUID(),
      fcmRegId: fcmToken,
    }
    this.saveUserDeviceRegistration(params).subscribe((res: any) => {
      if (res.Result == "Success") {
        localStorage.setItem("isRegisteredForNotification", "true");
        this.registerServiceWorker();
      }
    }, (err: HttpErrorResponse) => {
      console.error(err);
    })
  }

  public saveUserDeviceRegistration(params: any) {
    let loginDetails = JSON.parse(localStorage.getItem('admin_Details') ?? "null");
    const parseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    let sendingData = {
      sellerId: Number(loginDetails.SellerID),
      userId: Number(loginDetails.UserID),
      createdBy: Number(loginDetails.UserID),
      userType: loginDetails.UserType,
      appType: environment.appName,
      deviceId: params.deviceId,
      fcmRegId: params.fcmRegId,
    }
    let url = this.baseUrl + '/api/Notification/SaveUserDeviceRegistration';
    // let url = this.baseUrl + '/api/Notification/SaveUserDeviceRegistrations';
    return this.http.post(url, sendingData, parseHeaders);
  }

  public deregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister().then((success) => {
            console.log('Service Worker deregistered:', success);
          });
        }
      });
    }
  }

  public initNotifyRegistration() {
    if (environment.production) {
      //PROMPT TO ASK PERMISION FROM USER
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          this.requestPermissionFromFirebase();

        } else {
          console.warn('Notification permission denied.');
        }
      })
    } 
  }

  public listenForMessages(): void {
    navigator.serviceWorker.addEventListener('message', (event) => {
      this.currentMessage.next(event);
    });

    // SUBSCRIPTION TO DISPLAY NOTIFICATION
    this.currentMessage.subscribe((message) => {
      if (message) {
        this.showNotification(message.notification.title, message.notification.body);
      }
    });
  }

  public unsubscribeNotification() {
    this.subscription.unsubscribe();
  }
}